// This file was automatically generated and should not be edited.

// ====================================================
// Domiain Graph Type and Interface Mappings
// ====================================================

import {
  DomainGraphType,
  DomainGraphInterface,
  InterfaceType,
  ObjectType,
} from 'app-core/framework/CoreObjectConstants';

/** @package */
export const DOMAIN_GRAPH_INTERFACE_INTEGRATION_MAP: Record<InterfaceType, Set<ObjectType>> = {
  [DomainGraphInterface.CAN_EDIT_WORKFLOW_SCHEMA_FIELD_VALUES]: new Set([
    DomainGraphType.WORKFLOW_OUTPUT_SCHEMA,
    DomainGraphType.WORKFLOW_TASK_SCHEMA,
  ]),
  [DomainGraphInterface.COLLABORATABLE]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.AA_SEQUENCE_SCHEMA,
    DomainGraphType.AGENT_FACTORY,
    DomainGraphType.AGENT_SKILL,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.CUSTOM_ENTITY_SCHEMA,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_OLIGO_SCHEMA,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.DNA_SEQUENCE_SCHEMA,
    DomainGraphType.ENTITY_SCHEMA,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_SCHEMA,
    DomainGraphType.EQUIPMENT_SCHEMA,
    DomainGraphType.FEATURE_LIBRARY,
    DomainGraphType.FIELDSET,
    DomainGraphType.FOLDER,
    DomainGraphType.MIXTURE,
    DomainGraphType.MIXTURE_SCHEMA,
    DomainGraphType.MOLECULE,
    DomainGraphType.MOLECULE_SCHEMA,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_CONJUGATE_SCHEMA,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.OLIGO_DUPLEX_SCHEMA,
    DomainGraphType.PROJECT,
    DomainGraphType.PROTEIN,
    DomainGraphType.PROTEIN_SCHEMA,
    DomainGraphType.REGISTRY,
    DomainGraphType.RESULT_SCHEMA,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_OLIGO_SCHEMA,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.RNA_SEQUENCE_SCHEMA,
    DomainGraphType.ROUTINE,
    DomainGraphType.RUN_SCHEMA,
    DomainGraphType.TEMPLATE_COLLECTION,
    DomainGraphType.WORKFLOW_TASK_SCHEMA,
    DomainGraphType.WORKLIST,
  ]),
  [DomainGraphInterface.CORE_OBJECT_ARCHIVABLE]: new Set([
    DomainGraphType.AA_MONOMER,
    DomainGraphType.AGENT_FACTORY,
    DomainGraphType.AGENT_SKILL,
    DomainGraphType.AGENT_SKILL_FILE,
    DomainGraphType.AI_MODEL,
    DomainGraphType.AUTOMATION_TEMPLATE,
    DomainGraphType.AUTOMATION_TEMPLATE_DATA_FRAME_VARIABLE,
    DomainGraphType.AUTOMATION_TEMPLATE_VARIABLE,
    DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2,
    DomainGraphType.BUSINESS_RULE,
    DomainGraphType.CANVAS_FOLDER_ARTIFACT,
    DomainGraphType.CHART,
    DomainGraphType.DATASET,
    DomainGraphType.EXAMPLE_TYPE,
    DomainGraphType.FILE,
    DomainGraphType.JELLYFISH,
    DomainGraphType.JELLYFISH_SCHEMA,
    DomainGraphType.LIBRARY_PARAMETER_DEFINITION,
    DomainGraphType.MCP_SERVER_CONFIG,
    DomainGraphType.MCP_SERVER_USER_CONFIG,
    DomainGraphType.PLATE_DESIGN_TEMPLATE,
    DomainGraphType.PREDICTION_BATCH,
    DomainGraphType.PROCEDURE,
    DomainGraphType.PROCEDURE_FLOWCHART,
    DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE,
    DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION,
    DomainGraphType.PROCEDURE_RUN,
    DomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE,
    DomainGraphType.PROCEDURE_RUN_REPLICATE_EDGE,
    DomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE,
    DomainGraphType.PROTEIN_FORMAT,
    DomainGraphType.REACTION,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.REQUEST_V2_SUBMISSION,
    DomainGraphType.ROUTINE,
    DomainGraphType.SALT,
    DomainGraphType.SAMPLE_TYPE,
    DomainGraphType.SOLVENT,
    DomainGraphType.STUDY,
    DomainGraphType.TENTACLE,
    DomainGraphType.TEST_DEFINITION,
    DomainGraphType.UNIT,
    DomainGraphType.UNIT_TYPE,
    DomainGraphType.VALIDATION_RULE,
    DomainGraphType.WORKSHEET,
  ]),
  [DomainGraphInterface.DATA_CATALOG_ITEM]: new Set([DomainGraphType.DATASET, DomainGraphType.FILE]),
  [DomainGraphInterface.HAS_CUSTOM_FIELDS]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DATASET,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.FILE,
    DomainGraphType.MIXTURE,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.PROTEIN,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.STAGE_ENTRY,
  ]),
  [DomainGraphInterface.HAS_PROVENANCE_URI]: new Set([
    DomainGraphType.AA_PART_LINK_FIELD_DEFINITION,
    DomainGraphType.AA_SEQUENCE_LINK_FIELD_DEFINITION,
    DomainGraphType.AA_SEQUENCE_SCHEMA,
    DomainGraphType.ANTIBODY_LINK_FIELD_DEFINITION,
    DomainGraphType.ANY_ENTITY_LINK_FIELD_DEFINITION,
    DomainGraphType.ASSAY_REQUEST_LINK_FIELD_DEFINITION,
    DomainGraphType.ASSAY_RESULT_LINK_FIELD_DEFINITION,
    DomainGraphType.ASSAY_RUN_LINK_FIELD_DEFINITION,
    DomainGraphType.AUTOMATION_TEMPLATE,
    DomainGraphType.AUTOMATION_TEMPLATE_VARIABLE,
    DomainGraphType.BASE_FIELD_DEFINITION,
    DomainGraphType.BASE_MOLECULE_LINK_FIELD_DEFINITION,
    DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2,
    DomainGraphType.BLOB_LINK_FIELD_DEFINITION,
    DomainGraphType.BOOLEAN_FIELD_DEFINITION,
    DomainGraphType.CHART,
    DomainGraphType.CUSTOM_ENTITY_LINK_FIELD_DEFINITION,
    DomainGraphType.CUSTOM_ENTITY_SCHEMA,
    DomainGraphType.DATA_FRAME,
    DomainGraphType.DATE_FIELD_DEFINITION,
    DomainGraphType.DATE_TIME_FIELD_DEFINITION,
    DomainGraphType.DNA_OLIGO_LINK_FIELD_DEFINITION,
    DomainGraphType.DNA_OLIGO_SCHEMA,
    DomainGraphType.DNA_PART_LINK_FIELD_DEFINITION,
    DomainGraphType.DNA_SEQUENCE_LINK_FIELD_DEFINITION,
    DomainGraphType.DNA_SEQUENCE_SCHEMA,
    DomainGraphType.DOCUMENT,
    DomainGraphType.DROPDOWN,
    DomainGraphType.DROPDOWN_LINK_FIELD_DEFINITION,
    DomainGraphType.DROPDOWN_OPTION,
    DomainGraphType.ENTITY_SCHEMA,
    DomainGraphType.ENTRY_LINK_FIELD_DEFINITION,
    DomainGraphType.ENTRY_SCHEMA,
    DomainGraphType.ENTRY_SUBTEMPLATE,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.EQUIPMENT_LINK_FIELD_DEFINITION,
    DomainGraphType.EQUIPMENT_SCHEMA,
    DomainGraphType.EXAMPLE_TYPE,
    DomainGraphType.FIELDSET_LINK_FIELD_DEFINITION,
    DomainGraphType.FILE,
    DomainGraphType.FLOAT_FIELD_DEFINITION,
    DomainGraphType.FORM_DEFINITION,
    DomainGraphType.INTEGER_FIELD_DEFINITION,
    DomainGraphType.JELLYFISH_SCHEMA,
    DomainGraphType.JSON_FIELD_DEFINITION,
    DomainGraphType.LIBRARY_PARAMETER_DEFINITION,
    DomainGraphType.LONG_TEXT_FIELD_DEFINITION,
    DomainGraphType.MIXTURE_LINK_FIELD_DEFINITION,
    DomainGraphType.MIXTURE_SCHEMA,
    DomainGraphType.MOLECULE_LINK_FIELD_DEFINITION,
    DomainGraphType.MOLECULE_SCHEMA,
    DomainGraphType.OLIGO_CONJUGATE_LINK_FIELD_DEFINITION,
    DomainGraphType.OLIGO_CONJUGATE_SCHEMA,
    DomainGraphType.OLIGO_DUPLEX_LINK_FIELD_DEFINITION,
    DomainGraphType.OLIGO_DUPLEX_SCHEMA,
    DomainGraphType.PIPELINE_STEP,
    DomainGraphType.PLATE_DESIGN_TEMPLATE,
    DomainGraphType.PROCEDURE,
    DomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION,
    DomainGraphType.PROCEDURE_PARAMETER,
    DomainGraphType.PROCEDURE_PARAMETER_VERSION,
    DomainGraphType.PROTEIN_FORMAT,
    DomainGraphType.PROTEIN_SCHEMA,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.RESULT_SCHEMA,
    DomainGraphType.RNA_OLIGO_LINK_FIELD_DEFINITION,
    DomainGraphType.RNA_OLIGO_SCHEMA,
    DomainGraphType.RNA_PART_LINK_FIELD_DEFINITION,
    DomainGraphType.RNA_SEQUENCE_LINK_FIELD_DEFINITION,
    DomainGraphType.RNA_SEQUENCE_SCHEMA,
    DomainGraphType.SALT,
    DomainGraphType.SCHEMA_LINK_FIELD_DEFINITION,
    DomainGraphType.SCRATCH_FILE,
    DomainGraphType.SOLVENT,
    DomainGraphType.STORABLE_LINK_FIELD_DEFINITION,
    DomainGraphType.SYSTEM_CATEGORY_LINK_FIELD_DEFINITION,
    DomainGraphType.TEMPLATE_COLLECTION,
    DomainGraphType.TEST_DEFINITION,
    DomainGraphType.TEXT_FIELD_DEFINITION,
    DomainGraphType.TRANSCRIPTION_LINK_FIELD_DEFINITION,
    DomainGraphType.TRANSLATION_LINK_FIELD_DEFINITION,
    DomainGraphType.UNIT,
    DomainGraphType.UNIT_TYPE,
    DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION,
    DomainGraphType.WORKFLOW_OUTPUT_SCHEMA,
    DomainGraphType.WORKFLOW_TASK_DEFINITION,
    DomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION,
    DomainGraphType.WORKFLOW_TASK_SCHEMA,
  ]),
  [DomainGraphInterface.HAS_SCHEMA]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.BOX,
    DomainGraphType.CONTAINER,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.LOCATION,
    DomainGraphType.MATRIX_PLATE,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.PROTEIN,
    DomainGraphType.RESULT,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.RUN,
    DomainGraphType.STAGE_ENTRY,
    DomainGraphType.STUDY,
    DomainGraphType.WELL_PLATE,
    DomainGraphType.WORKFLOW_TASK,
  ]),
  [DomainGraphInterface.STARRABLE]: new Set([
    DomainGraphType.ANALYSIS,
    DomainGraphType.AUTOMATION_TEMPLATE,
    DomainGraphType.CHAT_SESSION,
    DomainGraphType.DATASET,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_SUBTEMPLATE,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.FILE,
    DomainGraphType.FOLDER,
    DomainGraphType.FORM_DEFINITION,
    DomainGraphType.JELLYFISH,
    DomainGraphType.PLATE_DESIGN_TEMPLATE,
    DomainGraphType.PROCEDURE,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.TEMPLATE_COLLECTION,
  ]),
  [DomainGraphInterface.STUDYABLE]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.ANALYSIS,
    DomainGraphType.ASSEMBLY,
    DomainGraphType.BOX,
    DomainGraphType.CONTAINER,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DATASET,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.ENTRY,
    DomainGraphType.FILE,
    DomainGraphType.MATRIX_PLATE,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.PLATE,
    DomainGraphType.PROTEIN,
    DomainGraphType.REQUEST_V2_SUBMISSION,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.TEST_ORDER,
    DomainGraphType.WELL_PLATE,
    DomainGraphType.WORKFLOW_TASK,
    DomainGraphType.WORKSHEET,
  ]),
};

/**
 * This file and map are autogenerated by `dev generate graphql`.
 *
 * If the value is incorrect, do one of the following:
 * - update the domain graph SDL file's `@identity(..., pluralized: "<pluralized_name>")` directive
 * - OR add to `DOMAIN_GRAPH_TYPE_TO_API_BASE` in `client/app-core/framework/CoreObjectIntrospectionUtils.ts`
 *
 *  @package
 */
export const DOMAIN_GRAPH_TYPE_TO_DEFAULT_API_BASE: Record<ObjectType, string> = {
  [DomainGraphType.AA_MONOMER]: '/1/api/aa-monomers',
  [DomainGraphType.AA_PART_LINK_FIELD_DEFINITION]: '/1/api/aa-part-link-field-definitions',
  [DomainGraphType.AA_SEQUENCE]: '/1/api/aa-sequences',
  [DomainGraphType.AA_SEQUENCE_LINK_FIELD_DEFINITION]: '/1/api/aa-sequence-link-field-definitions',
  [DomainGraphType.AA_SEQUENCE_SCHEMA]: '/1/api/aa-sequence-schemas',
  [DomainGraphType.AGENT_FACTORY]: '/1/api/agent-factories',
  [DomainGraphType.AGENT_MEMORY]: '/1/api/agent-memories',
  [DomainGraphType.AGENT_SKILL]: '/1/api/agent-skills',
  [DomainGraphType.AGENT_SKILL_FILE]: '/1/api/agent-skill-files',
  [DomainGraphType.AI_MODEL]: '/1/api/ai-models',
  [DomainGraphType.ANALYSIS]: '/1/api/analyses',
  [DomainGraphType.ANTIBODY_LINK_FIELD_DEFINITION]: '/1/api/antibody-link-field-definitions',
  [DomainGraphType.ANY_ENTITY_LINK_FIELD_DEFINITION]: '/1/api/any-entity-link-field-definitions',
  [DomainGraphType.APP_CANVAS]: '/1/api/app-canvases',
  [DomainGraphType.APP_DEFINITION]: '/1/api/app-definitions',
  [DomainGraphType.APP_DEFINITION_VERSION]: '/1/api/app-definition-versions',
  [DomainGraphType.APP_INSTALLATION]: '/1/api/app-installations',
  [DomainGraphType.APP_SESSION]: '/1/api/app-sessions',
  [DomainGraphType.ASSAY_REQUEST_LINK_FIELD_DEFINITION]: '/1/api/assay-request-link-field-definitions',
  [DomainGraphType.ASSAY_RESULT_LINK_FIELD_DEFINITION]: '/1/api/assay-result-link-field-definitions',
  [DomainGraphType.ASSAY_RUN_LINK_FIELD_DEFINITION]: '/1/api/assay-run-link-field-definitions',
  [DomainGraphType.ASSEMBLY]: '/1/api/assemblies',
  [DomainGraphType.ASYNC_TASK]: '/1/api/async-tasks',
  [DomainGraphType.ATTACHMENT]: '/1/api/attachments',
  [DomainGraphType.AUDIT_LOG]: '/1/api/audit-logs',
  [DomainGraphType.AUTOMATION_TEMPLATE]: '/1/api/automation-templates',
  [DomainGraphType.AUTOMATION_TEMPLATE_DATA_FRAME_VARIABLE]:
    '/1/api/automation-template-data-frame-variables',
  [DomainGraphType.AUTOMATION_TEMPLATE_VARIABLE]: '/1/api/automation-template-variables',
  [DomainGraphType.AV_SCAN_RECORD]: '/1/api/av-scan-records',
  [DomainGraphType.BASE_FIELD_DEFINITION]: '/1/api/base-field-definitions',
  [DomainGraphType.BASE_MOLECULE_LINK_FIELD_DEFINITION]: '/1/api/base-molecule-link-field-definitions',
  [DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2]: '/1/api/schemas',
  [DomainGraphType.BLOB_LINK_FIELD_DEFINITION]: '/1/api/blob-link-field-definitions',
  [DomainGraphType.BLOCK_VISUALIZATION]: '/1/api/block-visualizations',
  [DomainGraphType.BOOLEAN_FIELD_DEFINITION]: '/1/api/boolean-field-definitions',
  [DomainGraphType.BOX]: '/1/api/boxes',
  [DomainGraphType.BOX_SCHEMA]: '/1/api/box-schemas',
  [DomainGraphType.BUSINESS_RULE]: '/1/api/business-rules',
  [DomainGraphType.CANVAS_DEFINITION]: '/1/api/canvas-definitions',
  [DomainGraphType.CANVAS_FOLDER_ARTIFACT]: '/1/api/canvas-folder-artifacts',
  [DomainGraphType.CANVAS_VERSION]: '/1/api/canvas-versions',
  [DomainGraphType.CHART]: '/1/api/charts',
  [DomainGraphType.CHAT_SESSION]: '/1/api/chat-sessions',
  [DomainGraphType.COLLABORATION]: '/1/api/collaborations',
  [DomainGraphType.CONFIG_IMPORT_HISTORY_ENTRY]: '/1/api/config-import-history-entries',
  [DomainGraphType.CONTAINER]: '/1/api/containers',
  [DomainGraphType.CONTAINER_SCHEMA]: '/1/api/container-schemas',
  [DomainGraphType.CREDIT_LIMIT]: '/1/api/credit-limits',
  [DomainGraphType.CUSTOM_ENTITY]: '/1/api/custom-entities',
  [DomainGraphType.CUSTOM_ENTITY_LINK_FIELD_DEFINITION]: '/1/api/custom-entity-link-field-definitions',
  [DomainGraphType.CUSTOM_ENTITY_SCHEMA]: '/1/api/custom-entity-schemas',
  [DomainGraphType.DATA_FRAME]: '/1/api/data-frames',
  [DomainGraphType.DATASET]: '/1/api/datasets',
  [DomainGraphType.DATE_FIELD_DEFINITION]: '/1/api/date-field-definitions',
  [DomainGraphType.DATE_TIME_FIELD_DEFINITION]: '/1/api/date-time-field-definitions',
  [DomainGraphType.DNA_OLIGO]: '/1/api/sequences',
  [DomainGraphType.DNA_OLIGO_LINK_FIELD_DEFINITION]: '/1/api/dna-oligo-link-field-definitions',
  [DomainGraphType.DNA_OLIGO_SCHEMA]: '/1/api/dna-oligo-schemas',
  [DomainGraphType.DNA_PART_LINK_FIELD_DEFINITION]: '/1/api/dna-part-link-field-definitions',
  [DomainGraphType.DNA_SEQUENCE]: '/1/api/sequences',
  [DomainGraphType.DNA_SEQUENCE_LINK_FIELD_DEFINITION]: '/1/api/dna-sequence-link-field-definitions',
  [DomainGraphType.DNA_SEQUENCE_SCHEMA]: '/1/api/dna-sequence-schemas',
  [DomainGraphType.DOCUMENT]: '/1/api/documents',
  [DomainGraphType.DROPDOWN]: '/1/api/dropdowns',
  [DomainGraphType.DROPDOWN_LINK_FIELD_DEFINITION]: '/1/api/dropdown-link-field-definitions',
  [DomainGraphType.DROPDOWN_OPTION]: '/1/api/dropdown-options',
  [DomainGraphType.ENTITY_SCHEMA]: '/1/api/entity-schemas',
  [DomainGraphType.ENTRY]: '/1/api/entries',
  [DomainGraphType.ENTRY_LINK_FIELD_DEFINITION]: '/1/api/entry-link-field-definitions',
  [DomainGraphType.ENTRY_SCHEMA]: '/1/api/entry-schemas',
  [DomainGraphType.ENTRY_SUBTEMPLATE]: '/1/api/subtemplates',
  [DomainGraphType.ENTRY_TEMPLATE]: '/1/api/templates',
  [DomainGraphType.ENZYME]: '/1/api/enzymes',
  [DomainGraphType.ENZYME_LIST]: '/1/api/enzyme-lists',
  [DomainGraphType.EQUIPMENT_LINK_FIELD_DEFINITION]: '/1/api/equipment-link-field-definitions',
  [DomainGraphType.EQUIPMENT_SCHEMA]: '/1/api/equipment-schemas',
  [DomainGraphType.EVENT_SUBSCRIPTION]: '/1/api/event-subscriptions',
  [DomainGraphType.EXAMPLE_TYPE]: '/1/api/example-types',
  [DomainGraphType.FEATURE_LIBRARY]: '/1/api/feature-libraries',
  [DomainGraphType.FEATURE_LIBRARY_ITEM]: '/1/api/feature-library-items',
  [DomainGraphType.FIELDSET]: '/1/api/fieldsets',
  [DomainGraphType.FIELDSET_LINK_FIELD_DEFINITION]: '/1/api/fieldset-link-field-definitions',
  [DomainGraphType.FILE]: '/1/api/files',
  [DomainGraphType.FLOAT_FIELD_DEFINITION]: '/1/api/float-field-definitions',
  [DomainGraphType.FOLDER]: '/1/api/folders',
  [DomainGraphType.FORM_DEFINITION]: '/1/api/form-definitions',
  [DomainGraphType.GERMLINE]: '/1/api/germlines',
  [DomainGraphType.GROUP_MEMBERSHIP]: '/1/api/group-memberships',
  [DomainGraphType.IN_APP_NOTIFICATION]: '/1/api/in-app-notifications',
  [DomainGraphType.INTEGER_FIELD_DEFINITION]: '/1/api/integer-field-definitions',
  [DomainGraphType.INTERNAL_PIPELINE]: '/1/api/internal-pipelines',
  [DomainGraphType.JELLYFISH]: '/1/api/jellyfishes',
  [DomainGraphType.JELLYFISH_SCHEMA]: '/1/api/jellyfish-schemas',
  [DomainGraphType.JSON_FIELD_DEFINITION]: '/1/api/json-field-definitions',
  [DomainGraphType.LABEL_TEMPLATE]: '/1/api/label-templates',
  [DomainGraphType.LADDER]: '/1/api/ladders',
  [DomainGraphType.LEGACY_APP_INSTALLATION]: '/1/api/legacy-app-installations',
  [DomainGraphType.LEGACY_DATA_IMPORT_RUN]: '/1/api/legacy-data-import-runs',
  [DomainGraphType.LIBRARY_PARAMETER_DEFINITION]: '/1/api/library-parameter-definitions',
  [DomainGraphType.LOCATION]: '/1/api/locations',
  [DomainGraphType.LOCATION_SCHEMA]: '/1/api/location-schemas',
  [DomainGraphType.LONG_TEXT_FIELD_DEFINITION]: '/1/api/long-text-field-definitions',
  [DomainGraphType.MATRIX_PLATE]: '/1/api/matrix-plates',
  [DomainGraphType.MATRIX_PLATE_SCHEMA]: '/1/api/matrix-plate-schemas',
  [DomainGraphType.MCP_SERVER_CONFIG]: '/1/api/mcp-server-configs',
  [DomainGraphType.MCP_SERVER_DEFINITION]: '/1/api/mcp-server-definitions',
  [DomainGraphType.MCP_SERVER_USER_CONFIG]: '/1/api/mcp-server-user-configs',
  [DomainGraphType.MIXTURE]: '/1/api/mixtures',
  [DomainGraphType.MIXTURE_LINK_FIELD_DEFINITION]: '/1/api/mixture-link-field-definitions',
  [DomainGraphType.MIXTURE_SCHEMA]: '/1/api/mixture-schemas',
  [DomainGraphType.MOLECULE]: '/1/api/molecules',
  [DomainGraphType.MOLECULE_LINK_FIELD_DEFINITION]: '/1/api/molecule-link-field-definitions',
  [DomainGraphType.MOLECULE_SCHEMA]: '/1/api/molecule-schemas',
  [DomainGraphType.NUCLEOTIDE_ALIGNMENT]: '/1/api/nucleotide-alignments',
  [DomainGraphType.OLIGO_CONJUGATE]: '/1/api/oligo-conjugates',
  [DomainGraphType.OLIGO_CONJUGATE_LINK_FIELD_DEFINITION]: '/1/api/oligo-conjugate-link-field-definitions',
  [DomainGraphType.OLIGO_CONJUGATE_SCHEMA]: '/1/api/oligo-conjugate-schemas',
  [DomainGraphType.OLIGO_DUPLEX]: '/1/api/oligo-duplexes',
  [DomainGraphType.OLIGO_DUPLEX_LINK_FIELD_DEFINITION]: '/1/api/oligo-duplex-link-field-definitions',
  [DomainGraphType.OLIGO_DUPLEX_SCHEMA]: '/1/api/oligo-duplex-schemas',
  [DomainGraphType.ORGANIZATION]: '/1/api/organizations',
  [DomainGraphType.PIPELINE_STEP]: '/1/api/pipeline-steps',
  [DomainGraphType.PLATE]: '/1/api/plates',
  [DomainGraphType.PLATE_DESIGN_TEMPLATE]: '/1/api/plate-design-templates',
  [DomainGraphType.PLATE_RECORD]: '/1/api/scratch-plates',
  [DomainGraphType.PLATE_SCHEMA]: '/1/api/plate-schemas',
  [DomainGraphType.POLICY]: '/1/api/policies',
  [DomainGraphType.PREDICTION_BATCH]: '/1/api/prediction-batches',
  [DomainGraphType.PREDICTION_JOB]: '/1/api/prediction-jobs',
  [DomainGraphType.PRINTER]: '/1/api/printers',
  [DomainGraphType.PROCEDURE]: '/1/api/procedures',
  [DomainGraphType.PROCEDURE_FLOWCHART]: '/1/api/procedure-flowcharts',
  [DomainGraphType.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY]:
    '/1/api/procedure-flowchart-config-version-proxies',
  [DomainGraphType.PROCEDURE_FLOWCHART_VERSION]: '/1/api/procedure-flowchart-versions',
  [DomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION]: '/1/api/procedure-method-definition-versions',
  [DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE]: '/1/api/procedure-method-execution-instances',
  [DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION]:
    '/1/api/procedure-method-execution-instance-associations',
  [DomainGraphType.PROCEDURE_PARAMETER]: '/1/api/procedure-parameters',
  [DomainGraphType.PROCEDURE_PARAMETER_CONFIRMATION_VALUE]: '/1/api/procedure-parameter-confirmation-values',
  [DomainGraphType.PROCEDURE_PARAMETER_MEASURED_VALUE]: '/1/api/procedure-parameter-measured-values',
  [DomainGraphType.PROCEDURE_PARAMETER_PLANNED_VALUE]: '/1/api/procedure-parameter-planned-values',
  [DomainGraphType.PROCEDURE_PARAMETER_VERSION]: '/1/api/procedure-parameter-versions',
  [DomainGraphType.PROCEDURE_RUN]: '/1/api/procedure-runs',
  [DomainGraphType.PROCEDURE_RUN_CONDITION]: '/1/api/procedure-run-conditions',
  [DomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE]: '/1/api/procedure-run-condition-replicates',
  [DomainGraphType.PROCEDURE_RUN_PLAN]: '/1/api/procedure-run-plans',
  [DomainGraphType.PROCEDURE_RUN_PLAN_CONDITION]: '/1/api/procedure-run-plan-conditions',
  [DomainGraphType.PROCEDURE_RUN_PLAN_REPLICATE_EDGE]: '/1/api/procedure-run-plan-replicate-edges',
  [DomainGraphType.PROCEDURE_RUN_REPLICATE_EDGE]: '/1/api/procedure-run-replicate-edges',
  [DomainGraphType.PROCEDURE_STEP_DEFINITION_VERSION]: '/1/api/procedure-step-definition-versions',
  [DomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE]: '/1/api/procedure-step-execution-instances',
  [DomainGraphType.PROJECT]: '/1/api/projects',
  [DomainGraphType.PROTEIN]: '/1/api/proteins',
  [DomainGraphType.PROTEIN_FORMAT]: '/1/api/protein-formats',
  [DomainGraphType.PROTEIN_SCHEMA]: '/1/api/protein-schemas',
  [DomainGraphType.PROTEIN_VERSION]: '/1/api/protein-versions',
  [DomainGraphType.PUBLISHING_RECORD]: '/1/api/publishing-records',
  [DomainGraphType.REACTION]: '/1/api/reactions',
  [DomainGraphType.REGISTRY]: '/1/api/registries',
  [DomainGraphType.REQUEST]: '/1/api/requests',
  [DomainGraphType.REQUEST_SCHEMA]: '/1/api/request-schemas',
  [DomainGraphType.REQUEST_TASK_SCHEMA]: '/1/api/request-task-schemas',
  [DomainGraphType.REQUEST_V2_DEFINITION]: '/1/api/request-v2-definitions',
  [DomainGraphType.REQUEST_V2_SUBMISSION]: '/1/api/request-v2-submissions',
  [DomainGraphType.RESULT]: '/1/api/results',
  [DomainGraphType.RESULT_SCHEMA]: '/1/api/result-schemas',
  [DomainGraphType.REVIEW_CHANGE]: '/1/api/review-changes',
  [DomainGraphType.RNA_OLIGO]: '/1/api/sequences',
  [DomainGraphType.RNA_OLIGO_LINK_FIELD_DEFINITION]: '/1/api/rna-oligo-link-field-definitions',
  [DomainGraphType.RNA_OLIGO_SCHEMA]: '/1/api/rna-oligo-schemas',
  [DomainGraphType.RNA_PART_LINK_FIELD_DEFINITION]: '/1/api/rna-part-link-field-definitions',
  [DomainGraphType.RNA_SEQUENCE]: '/1/api/sequences',
  [DomainGraphType.RNA_SEQUENCE_LINK_FIELD_DEFINITION]: '/1/api/rna-sequence-link-field-definitions',
  [DomainGraphType.RNA_SEQUENCE_SCHEMA]: '/1/api/rna-sequence-schemas',
  [DomainGraphType.ROUTINE]: '/1/api/routines',
  [DomainGraphType.ROUTINE_EXECUTION]: '/1/api/routine-executions',
  [DomainGraphType.RUN]: '/1/api/runs',
  [DomainGraphType.RUN_SCHEMA]: '/1/api/run-schemas',
  [DomainGraphType.SALT]: '/1/api/salts',
  [DomainGraphType.SAMPLE_DEFINITION]: '/1/api/sample-definitions',
  [DomainGraphType.SAMPLE_TYPE]: '/1/api/sample-types',
  [DomainGraphType.SCHEMA_LINK_FIELD_DEFINITION]: '/1/api/schema-link-field-definitions',
  [DomainGraphType.SCRATCH_FILE]: '/1/api/scratch-files',
  [DomainGraphType.SERVICE_PRINCIPAL]: '/1/api/service-principals',
  [DomainGraphType.SOLVENT]: '/1/api/solvents',
  [DomainGraphType.SQL_DASHBOARD]: '/1/api/sql-dashboards',
  [DomainGraphType.SQL_DASHBOARD_BLOCK]: '/1/api/sql-dashboard-blocks',
  [DomainGraphType.SQL_DASHBOARD_LINK]: '/1/api/sql-dashboard-links',
  [DomainGraphType.STAGE_ENTRY]: '/1/api/stage-entries',
  [DomainGraphType.STAR]: '/1/api/stars',
  [DomainGraphType.STATIC_VALIDATION_RULE_TEMPLATE]: '/1/api/static-validation-rule-templates',
  [DomainGraphType.STORABLE_LINK_FIELD_DEFINITION]: '/1/api/storable-link-field-definitions',
  [DomainGraphType.STUDY]: '/1/api/studies',
  [DomainGraphType.STUDY_ITEM_ASSOCIATION]: '/1/api/study-item-associations',
  [DomainGraphType.STUDY_SAMPLE_TEST_PLAN]: '/1/api/study-sample-test-plans',
  [DomainGraphType.STUDY_SCHEMA]: '/1/api/study-schemas',
  [DomainGraphType.SYSTEM_CATEGORY]: '/1/api/system-categories',
  [DomainGraphType.SYSTEM_CATEGORY_LINK_FIELD_DEFINITION]: '/1/api/system-category-link-field-definitions',
  [DomainGraphType.TEAM]: '/1/api/teams',
  [DomainGraphType.TEMPLATE_COLLECTION]: '/1/api/template-collections',
  [DomainGraphType.TENANT_CONFIG]: '/1/api/tenant-configs',
  [DomainGraphType.TENTACLE]: '/1/api/tentacles',
  [DomainGraphType.TEST_DEFINITION]: '/1/api/test-definitions',
  [DomainGraphType.TEST_ORDER]: '/1/api/test-orders',
  [DomainGraphType.TEXT_FIELD_DEFINITION]: '/1/api/text-field-definitions',
  [DomainGraphType.TRANSCRIPTION_LINK_FIELD_DEFINITION]: '/1/api/transcription-link-field-definitions',
  [DomainGraphType.TRANSLATION_LINK_FIELD_DEFINITION]: '/1/api/translation-link-field-definitions',
  [DomainGraphType.TREATMENT_GROUP]: '/1/api/treatment-groups',
  [DomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN]: '/1/api/trial-sample-testing-study-designs',
  [DomainGraphType.UNIT]: '/1/api/units',
  [DomainGraphType.UNIT_TYPE]: '/1/api/unit-types',
  [DomainGraphType.USER]: '/1/api/users',
  [DomainGraphType.VALIDATION_RULE]: '/1/api/validation-rules',
  [DomainGraphType.WAREHOUSE_CREDENTIAL]: '/1/api/warehouse-credentials',
  [DomainGraphType.WAREHOUSE_CUSTOM_VIEW]: '/1/api/warehouse-custom-views',
  [DomainGraphType.WELL_PLATE]: '/1/api/well-plates',
  [DomainGraphType.WELL_PLATE_SCHEMA]: '/1/api/well-plate-schemas',
  [DomainGraphType.WORKFLOW_END_NODE_DETAILS]: '/1/api/process-end-node-details',
  [DomainGraphType.WORKFLOW_FLOWCHART_CONFIG]: '/1/api/process-flowchart-configs',
  [DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION]: '/1/api/process-flowchart-config-versions',
  [DomainGraphType.WORKFLOW_FLOWCHART_EDGE_CONFIG]: '/1/api/process-flowchart-edge-configs',
  [DomainGraphType.WORKFLOW_FLOWCHART_NODE_CONFIG]: '/1/api/process-flowchart-node-configs',
  [DomainGraphType.WORKFLOW_OUTPUT]: '/1/api/process-outputs',
  [DomainGraphType.WORKFLOW_OUTPUT_NODE_DETAILS]: '/1/api/process-output-node-details',
  [DomainGraphType.WORKFLOW_OUTPUT_SCHEMA]: '/1/api/process-output-schemas',
  [DomainGraphType.WORKFLOW_ROOT_NODE_DETAILS]: '/1/api/process-root-node-details',
  [DomainGraphType.WORKFLOW_ROUTER_FUNCTION]: '/1/api/process-router-functions',
  [DomainGraphType.WORKFLOW_ROUTER_NODE_DETAILS]: '/1/api/process-router-node-details',
  [DomainGraphType.WORKFLOW_TASK]: '/1/api/process-tasks',
  [DomainGraphType.WORKFLOW_TASK_DEFINITION]: '/1/api/process-task-definitions',
  [DomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION]: '/1/api/process-task-definition-versions',
  [DomainGraphType.WORKFLOW_TASK_GROUP]: '/1/api/processes',
  [DomainGraphType.WORKFLOW_TASK_NODE_DETAILS]: '/1/api/process-task-node-details',
  [DomainGraphType.WORKFLOW_TASK_SCHEMA]: '/1/api/process-task-schemas',
  [DomainGraphType.WORKLIST]: '/1/api/worklists',
  [DomainGraphType.WORKSHEET]: '/1/api/worksheets',
};
